import { MatDialogWidth } from '../enums/mat-dialog-width';
import { SharedDialogOpenOptions } from '../models/shared-dialog-open-options';

/** Baseline options merged before each {@link SharedDialogService.open} call. */
export const SHARED_DIALOG_DEFAULT_OPTIONS: SharedDialogOpenOptions = {
    width: MatDialogWidth.SM,
    disableClose: false,
    hasBackdrop: true,
    autoFocus: 'first-tabbable',
    restoreFocus: true,
    closeOnNavigation: true,
};
